import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, Tag } from "antd";
import { userHasPermission } from '../../../../../swzutils/UserPermissionsUtil';
import HasPermissions from "../../../../../containers/HasPermissions";
import { EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import FeatureEditModal from "./FeatureEditModal";
import { DateTimeFormat } from '../../../components/FormattersTS';
import { loggedInUserSelector } from "../../../../../store/slice/auth";
import FeatureComplianceRule from "../FeatureComplianceRule";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { capitalise } from "../../../../../util/FormatUtil";
import { useAppSelector } from "../../../../../store";
const FeatureTable = () => {
    const tableRef = useRef(null);
    const [featureEditModalVisible, setFeatureEditModalVisible] = useState(false);
    const [editFeature, setEditFeature] = useState(undefined);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const showFeatureEditModal = (feature) => {
        setEditFeature(feature);
        setFeatureEditModalVisible(true);
    };
    const hideFeatureEditModal = () => {
        setEditFeature(undefined);
        setFeatureEditModalVisible(false);
    };
    const columns = [{
            title: 'Description',
            key: 'description',
            dataIndex: 'description',
            width: '25%'
        }, {
            title: 'Type',
            key: 'type',
            dataIndex: 'type',
            width: '10%',
            render: (text, row) => {
                return capitalise(row.type.toLowerCase());
            }
        }, {
            title: 'Compliance Doc',
            key: 'complianceDocumentRule',
            dataIndex: 'complianceDocumentRule',
            width: '10%',
            render: (text /*, record: FeatureResponse*/) => {
                return FeatureComplianceRule.fromString(text)?.description;
            }
        }, {
            title: 'Expiry Date',
            key: 'complianceExpiryDateRule',
            dataIndex: 'complianceExpiryDateRule',
            width: '10%',
            render: (text /*, record: FeatureResponse*/) => {
                return FeatureComplianceRule.fromString(text)?.description;
            }
        }, {
            title: 'Vehicle Categories',
            key: 'vehicleCategories',
            width: '25%',
            render: (text, record) => {
                return record.vehicleCategories?.map(vehicleCategory => _jsx(Tag, { children: vehicleCategory }, vehicleCategory));
            }
        }, {
            title: 'Disable',
            key: 'disabledAt',
            dataIndex: 'disabledAt',
            width: '10%',
            render: (text, record) => {
                if (record.disabledAt) {
                    return _jsx(DateTimeFormat, { value: record.disabledAt });
                }
                return null;
            }
        }, {
            title: 'Action',
            key: 'action',
            width: '10%',
            condition: userHasPermission(loggedInUser, ['admin:feature:update']),
            render: (text, record) => {
                return (_jsx("span", { className: "actions", children: _jsxs(Button, { onClick: () => showFeatureEditModal(record), children: [_jsx(EditOutlined, {}), "\u00A0Edit"] }) }));
            }
        }];
    return (_jsxs("article", { className: "article swz-fixed-table-article", children: [_jsx("h2", { className: "article-title", children: "Features" }), _jsxs("div", { className: "table-operations clearfix", children: [_jsx(HasPermissions, { permissions: ['admin:feature:create'], children: _jsx(Button, { icon: _jsx(PlusOutlined, {}), onClick: () => showFeatureEditModal(undefined), children: "Add a new Feature" }) }), _jsx(Button, { className: "pull-right", onClick: refresh, title: "Refresh", icon: _jsx(ReloadOutlined, {}) })] }), _jsx(PaginatedFilterableTable, { tableKey: 'featuresTable', ref: tableRef, dataUri: "/admin/v1/features", columns: columns, refreshOnSelectedTenantChanged: false, initialFilters: {
                    includeDisabled: [true]
                } }), _jsx(FeatureEditModal, { open: featureEditModalVisible, editFeature: editFeature, onCancel: hideFeatureEditModal, onUpdated: () => {
                    refresh();
                    hideFeatureEditModal();
                } })] }));
};
export default FeatureTable;
